import React from "react";
import { BrowserRouter, Switch, Route, Redirect, Link } from "react-router-dom";
import Home from "./components/pages/Home";
import SignIn from "./components/auth/SignIn";
import SignUp from "./components/auth/SignUp";
import AdminDashboard from "./components/pages/AdminDashboard";
import "materialize-css";
import EntryEditor from "./components/pages/Blog/EntryEditor";
import EntryView from "./components/pages/Blog/EntryView";
import Blog from "./components/pages/Blog";
import Contact from "./components/pages/Contact";
import About from "./components/pages/About";
import NavMenu from "./components/layout/NavMenu";
import logo from "./resources/logo.svg";
import LangToggle from "./components/utils/LangToggle";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const App = () => {
  return (
    <BrowserRouter>
      <NavMenu />
      <div className="container">
        <div className="brand-mobile brand">
          <Link to="/" className="nav-link">
            <img src={logo} className="app-logo" alt="logo" />
            <h2>
              <span className="link-text">RAURU</span>
            </h2>
          </Link>
          <LangToggle />
        </div>
        <ToastContainer />

        <Switch>
          <Redirect exact from="/blog" to="/blog/1" />
          <Redirect exact from="/admin" to="/admin/1" />

          <Route path="/signin" component={SignIn} />
          <Route path="/signup" component={SignUp} />
          <Route path="/admin/:page" component={AdminDashboard} />
          <Route path="/blog/:page" component={Blog} />
          <Route path="/entry/:key" component={EntryView} />
          <Route
            path="/new-entry"
            render={() => <EntryEditor action="create" />}
          />
          <Route
            path="/edit-entry/:key"
            render={() => <EntryEditor action="edit" />}
          />
          <Route path="/about_me" component={About} />
          <Route path="/Contact" component={Contact} />
          <Route path="/" component={Home} />
        </Switch>
      </div>
    </BrowserRouter>
  );
};

export default App;
